import { connect } from 'react-redux'
import { TdsField } from '@trv-tds/react'

import type { ClaimHandlerType } from '../claim/types'
import type { GlobalState } from '../types'
import type { UploadIdentityType } from './types'
import { getClaimHandlers, getIdentityValues } from './upload-selectors'

type UploaderInfoProps = {
  claimNumber: string
  identity: UploadIdentityType
  claimHandlers: ClaimHandlerType[]
}

const UploaderInfoComponent = ({ claimNumber, identity, claimHandlers }: UploaderInfoProps) => (
  <div>
    <TdsField>
      <span slot='label'><h4>Claim Number</h4></span>
      <span>{claimNumber}</span>
    </TdsField>
    <TdsField>
      <span slot='label'><h4>Your Name or Business</h4></span>
      <span>{identity.name}</span>
    </TdsField>
    <TdsField>
      <span slot='label'><h4>Select Files</h4></span>
      <span>
        Use the {claimHandlers.length > 0
          ? 'drop down menus below to select a recipient and '
          : 'drop down below to '}
          describe the files being added. Select &quot;Upload Files&quot; when ready.
      </span>
    </TdsField>
  </div>
)

const mapStateToProps = (state: GlobalState) => ({
  claimNumber: state.claim.claimDetails.claim,
  identity: getIdentityValues(state),
  claimHandlers: getClaimHandlers(state)
})

const UploaderInfo = connect(mapStateToProps)(UploaderInfoComponent)

export {
  UploaderInfo
}
